<template>
    <ion-page>
        <ion-content>
            <ion-grid>
                <ion-row class="content-row" align-items-center>
                    <ion-col size-xs="12" offset-xs="0" size-sm="8" offset-sm="2" size-md="6" offset-md="3" size-lg="4" offset-lg="4" text-center>
                        <ion-img class="logo" :src="require('@/assets/logo_full_small.png')"></ion-img>
                        <ion-card class="signup">
                            <ion-card-header v-if="!processingSignup">
                                <ion-card-title text-left color="primary">{{ $t('screens.location-city.choose') }}</ion-card-title>
                            </ion-card-header>
                            <ion-card-content v-if="!processingSignup">
                                <ion-searchbar @input="searchString = $event.target.value" @ionClear="searchString = ''"></ion-searchbar>
                                <ion-button class="scroll" color="medium" fill="clear" @click="scrollList(0)" :disabled="scrollPosition <= 0"><ion-icon name="arrow-up" mode="ios"></ion-icon></ion-button>
                                <div class="scroller" ref="scroller">
                                    <transition-group name="slide-fade">
                                        <ion-card v-for="city in filteredCities" :key="city.id" class="city" @click="signUp(city.id)">
                                            <ion-item lines="none"><ion-avatar><ion-label text-center>{{city.name[0]}}</ion-label></ion-avatar><ion-label>{{city.name}}</ion-label><ion-icon class="arrow" name="arrow-forward" mode="ios" size="small" slot="end"></ion-icon></ion-item>
                                        </ion-card>
                                    </transition-group>
                                </div>
                                <ion-button class="scroll" color="medium" fill="clear" @click="scrollList(1)" :disabled="scrollPosition >= scrollMax"><ion-icon name="arrow-down" mode="ios"></ion-icon></ion-button>
                                <div class="divider"></div>
                                <ion-button size="default" color="light" class="choose" @click="notListed">{{ $t('screens.location-city.not-listed') }}</ion-button>
                            </ion-card-content>
                            <ion-card-content v-else>
                                <Loading :msg="$t('screens.location-city.give-us-processing')"></Loading>
                            </ion-card-content>
                        </ion-card>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>

<script>
import helpers from '@/helpers';
import Loading from '@/components/Loading.vue';
import axios from 'axios';

export default {
    name: 'location-city',
    components: {
        Loading
    },
    data() {
        return {
            scrollPosition: 0,
            regionId: this.$store.state.signUp.regionId,
            scrollMax: 1,
            searchString: '',
            /*cities: {
                "1": [
                    {id: "BFS", name: "Belfast"},
                    {id: "BHX", name: "Birmingham"},
                    {id: "BOH", name: "Bournemouth"},
                    {id: "BRS", name: "Bristol"},
                    {id: "CWL", name: "Cardiff"},
                    {id: "DSA", name: "Doncaster"},
                    {id: "EDI", name: "Edinburgh"},
                    {id: "EXT", name: "Exeter"},
                    {id: "GLA", name: "Glasgow"},
                    {id: "LBA", name: "Leeds"},
                    {id: "LPL", name: "Liverpool"},
                    {id: "LON", name: "London"},
                    {id: "MAN", name: "Manchester"},
                    {id: "NCL", name: "Newcastle"},
                ],
                "2": [
                    {id: "ATL", name: "Atlanta"},
                    {id: "NYC", name: "New York"},
                    {id: "PHL", name: "Philadelphia"},
                    {id: "PIT", name: "Pittsburgh"},
                    {id: "WAS", name: "Washington"},
                ],
                "3": [
                    {id: "CHI", name: "Chicago"},
                    {id: "CVG", name: "Cincinnati"},
                    {id: "CLE", name: "Cleveland"},
                    {id: "DEN", name: "Denver"},
                    {id: "DTT", name: "Detroit"},
                    {id: "MSP", name: "Minneapolis"},
                ],
                "4": [
                    {id: "LAS", name: "Las Vegas"},
                    {id: "LAX", name: "Los Angeles"},
                    {id: "OAK", name: "Oakland"},
                    {id: "PHX", name: "Phoenix"},
                    {id: "PDX", name: "Portland"},
                    {id: "SLC", name: "Salt Lake City"},
                    {id: "SAN", name: "San Diego"},
                    {id: "SFO", name: "San Francisco"},
                    {id: "SJC", name: "San Jose"},
                    {id: "SEA", name: "Seattle"},
                ],
                "5": [
                    {id: "AUS", name: "Austin"},
                    {id: "CLT", name: "Charlotte"},
                    {id: "DFW", name: "Dallas"},
                    {id: "FLL", name: "Fort Lauderdale"},
                    {id: "HOU", name: "Houston"},
                    {id: "MIA", name: "Miami"},
                    {id: "MSY", name: "New Orleans"},
                    {id: "ORL", name: "Orlando"},
                    {id: "TPA", name: "Tampa"},
                ],
                "6": [
                    {id: "ALC", name: "Alicante"},
                    {id: "BCN", name: "Barcelona"},
                    {id: "BIO", name: "Bilbao"},
                    {id: "GRO", name: "Girona"},
                    {id: "MAD", name: "Madrid"},
                    {id: "AGP", name: "Malaga"},
                    {id: "PMI", name: "Mallorca"},
                    {id: "SDR", name: "Santander"},
                    {id: "SCQ", name: "Santiago de Compostela"},
                    {id: "SVQ", name: "Sevilla"},
                    {id: "VLC", name: "Valencia"},
                    {id: "ZAZ", name: "Zaragoza"},
                ],
            },*/
            cities: [],
            filteredCities: [],
            processingSignup: false,
        }
    },
    beforeCreate() {
        if (!this.$store.state.signedIn && !this.$store.state.signUp.email) {
            this.$router.push('/signup')
        }
        if (!this.$store.state.signUp.regionId) {
            this.$router.push('/location-region')
        }
    },
    beforeMount() {
        const airports = localStorage.getObject('from_airports');
        // eslint-disable-next-line no-unused-vars
        for (const airport of airports) {
            if (airport.region_id === this.regionId)
                this.cities.push(airport);
        }
        this.$logger.debug(this.cities);
        this.filteredCities = this.cities;
    },
    methods: {
        handleInput: function(event) {
            const query = event.target.value.toLowerCase();
            /*this.cities[this.regionId].forEach(city => {
                city.show = city.name.toLowerCase().indexOf(query) > -1;
                this.$logger.debug(city);
            })*/
            this.regionCities = this.cities.filter(city => {
                return city.name.toLowerCase().indexOf(query) > -1;
            })
            this.$logger.debug(this.regionCities);
        },
        scrollList: function(dir) {
            const offset = 70;
            this.scrollMax = this.$refs.scroller.scrollHeight - this.$refs.scroller.clientHeight;
            this.scrollPosition = this.$refs.scroller.scrollTop + ( dir == 1 ? offset : -offset );
            this.$refs.scroller.scrollBy({top: dir == 1 ? offset : -offset, left: 0, behavior: 'smooth'});
        },
        signUp: function(cityId) {
            let pwd;

            do {
                pwd = helpers.generateRandomPassword();
            } while( !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!\-_.:;?[\]{}()/&%$#@=\\*+])[A-Za-z\d!\-_.:;?[\]{}()/&%$#@=\\*+]{8,}$/.test(pwd) );

            this.processingSignup = true;

            if(this.$store.state.signedIn) {
                axios.put(process.env.VUE_APP_API_FEED_BASE + '/profile',
                    {
                        "fromCityId": cityId
                    },
                    {
                        headers: {Authorization: `Bearer ${this.$store.state.user.signInUserSession.getIdToken().getJwtToken()}`},
                    }
                ).then(response => {
                    this.$logger.debug(response);
                    this.$router.push('/');
                }).catch((err) => {
                    this.$logger.error(err);
                });
            } else {
                this.$Amplify.Auth.signUp({
                    username: this.$store.state.signUp.email,
                    password: pwd,
                    attributes: {
                        email: this.$store.state.signUp.email,
                        'custom:fromCityId': cityId
                    },
                    clientMetadata: {
                        locale: this.$i18n.locale
                    }
                }).then(data => {
                    pwd = '';
                    this.$logger.debug(data);

                    this.$AmplifyEventBus.$emit('authState', 'confirmSignUp');
                    this.$router.push({name: 'signup-success', params: {user: data.userSub}});
                    //this.$router.push('/wizard/email');
                }).catch(err => {
                    pwd = '';
                    this.$logger.error(err);
                });
            }
        },
        sendMessage: function(city) {
            this.$logger.debug(city, this.$store.state.signUp.email);
            axios.post(process.env.VUE_APP_API_VERIFY_BASE + '/not-listed',
                {
                    message: 'Could you please add the city: ' + city,
                    email: this.$store.state.signUp.email
                }
            ).then(response => {
                this.$logger.debug(response);
                this.$router.push('/thanks');
            }).catch((err) => {
                this.$logger.error(err);
            });
        },
        notListed: function() {
            return this.$ionic.alertController.create({
                header: this.$t('screens.location-city.modal-not-listed-title'),
                cssClass: 'ion-text-justify',
                message:  this.$t('screens.location-city.modal-not-listed-message'),
                inputs: [
                    {
                        placeholder: this.$t('screens.location-city.modal-not-listed-placeholder'),
                        type: 'text',
                        name: 'city'
                    }],
                buttons: [
                    {
                        text: this.$t('screens.location-city.modal-not-listed-no'),
                        role: 'cancel',
                        cssClass: 'alert-cancel-button',
                        handler: data => {
                            this.$logger.debug('Confirm Cancel', data);
                        },
                    },
                    {
                        text: this.$t('screens.location-region.modal-not-listed-yes'),
                        handler: (data) => {
                            this.$logger.debug('Confirm Okay', data);
                            this.sendMessage(data.region);
                        },
                    },
                ],
            }).then(a => a.present())
        },
    },
    watch: {
        searchString: helpers.debounce(function (newVal) {
            this.filteredCities = this.cities.filter(city => {
                return city.name.toLowerCase().indexOf(newVal) > -1;
            });
        }, 400)
    }
}
</script>

<style scoped>
    ion-content {
        --background: url('~@/assets/bg/bg7.jpg') no-repeat center center / cover;
    }

    ion-grid {
        height: 100%;
        font-family: 'Nunito', sans-serif;
        padding: 1em;
        padding-top: .5em;
    }

    ion-input {
        margin-left: .5em;
    }

    ion-item {
        --background: rgba(255,255,255,.6);
        margin-left: 1%;
        margin-bottom: .5em;
        --min-height: 1em;
    }

    ion-button {
        margin-top: 1em;
    }

    ion-button.choose {
        margin-top: 0;
    }

    ion-label {
        font-family: 'Nunito', sans-serif;
        color: #fff;
        padding: .25em 0;
        display: block;
    }


    ion-list {
        padding: 0;
        margin: 0;
        background: unset;
    }

    ion-card-content {
        flex-direction: column;
        height: 30em;
    }

    .scroller {
        overflow-y: scroll;
        padding-bottom: 1em;
        height: 17em;
    }

    .scroller::-webkit-scrollbar {
        display: none;
    }

    ion-card-header {
        --background: none;
        padding-bottom: .5em;
    }

    ion-card {
        --background: rgba(255,255,255,.8);
        font-family: 'Nunito', sans-serif;
    }

    ion-card-title {
        --color: #333;
        font-size: 2.2em;
        font-weight: bold;
    }

    ion-col {
        padding: 0;
    }

    ion-avatar {
        height: 1.5em;
        width: 1.5em;
        margin: .5em .5em .5em 0em;
        background-color: #666;
    }

    ion-button ion-icon {
        margin-right: .5em;
    }

    ion-button.scroll {
        margin: 0;
        height: 1.5em;
    }

    ion-button.scroll ion-icon {
        margin: 0;
    }

    .city {
        padding: 0;
        margin-top: 0;
    }

    .city ion-avatar ion-label {
        font-family: 'Nunito', sans-serif;
        font-weight: bold;
        font-size: 1em;
        color: #fff;
        padding: 0;
    }

    .city ion-item {
        --inner-padding-end: .5em;
        --padding-start: .5em;
        margin: 0;
        cursor: pointer;
    }

    .city:hover {
        background-color: #ffccdd;
    }

    .city ion-label {
        color: #666;
        font-size: 1em;
        margin: 0;
    }

    .city ion-icon {
        margin: 0;
    }

    .city .arrow {
        margin-left: .5em;
    }

    .divider {
        margin: 0 auto;
    }

    .slide-fade-leave-active, .slide-fade-enter-active {
        transition: all .25s ease;
        max-height: 2em;
    }
    .slide-fade-enter, .slide-fade-leave-to {
        max-height: 0;
        /*transform: translateX(10px);*/
        opacity: 0;
    }
</style>